const key = userID => `dm-pending-recharge-${userID}`;

export function readPendingRecharge(userID) {
  try { return JSON.parse(sessionStorage.getItem(key(userID)) || 'null'); }
  catch (error) { return null; }
}

export function savePendingRecharge(userID, payment) {
  try { sessionStorage.setItem(key(userID), JSON.stringify(payment)); }
  catch (error) { /* La conferma resta comunque disponibile nel popup corrente. */ }
}

export function clearPendingRecharge(userID) {
  try { sessionStorage.removeItem(key(userID)); }
  catch (error) { /* Una ripetizione della registrazione è idempotente sul server. */ }
}